export type BudgetStatus = 'ok' | 'warn' | 'over';

export interface Category {
  /** Backend category id — what budgets and transactions are filed under, and the route param. */
  id: string;
  name: string;
  icon?: string;
  color?: string;
  /** The vessel's "Other" fallback: it takes deleted categories' entries, and cannot be edited. */
  isDefault: boolean;
  hasPlan: boolean;
  planned: number;
  spent: number;
}

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const STATUS_LABEL: Record<BudgetStatus, string> = {
  ok: 'On Track',
  warn: 'Watch',
  over: 'Needs Review',
};

export const STATUS_CLASS: Record<BudgetStatus, string> = {
  ok: 'chipOk',
  warn: 'chipWarn',
  over: 'chipOver',
};

export const PROGRESS_CLASS: Record<BudgetStatus, string> = {
  ok: 'fillOk',
  warn: 'fillWarn',
  over: 'fillOver',
};

export const DEFAULT_ICON_COLOR = '#677687';
